import styled from 'styled-components';
import { UiModal } from 'components';
import { getGlobalStore } from 'stores';

const Modal = styled(UiModal)`
  padding: 0;

  .inner {
    padding: 0;

    border-radius: 12px;
  }
`;

const OpenStyled = styled.div`
  .banner-img {
    background: url(${require('./images/group/turelove-banner.png')}) 0 0 /
      contain no-repeat;
    width: 400px;
    height: 200px;
    margin: -20px -24px 0;
  }

  h6 {
    padding: 20px 0 20px;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
  }

  p {
    text-align: center;
  }

  .actions {
    text-align: center;
    margin: 50px auto 0;

    .btn {
      width: 170px;
    }
  }
`;

const OpenTipPopup = (props) => {
  const onOpen = () => {
    getGlobalStore().modal.remove('openGroupTip');
  };
  return (
    <Modal
      width={'400px'}
      isShowFooter={false}
      maskCloseEnable={true}
      {...props}
    >
      <OpenStyled>
        <div className="banner-img"></div>
        <h6>开通真爱团</h6>
        <p>新版真爱团已上线，没有开通真爱团不能开播哦！</p>

        <div className="actions">
          {/*<button className="btn btn-lg btn-round btn-warn" onClick={onOpen}>立即开通</button>*/}
          <a
            className="btn btn-lg btn-round btn-warn"
            href="/user.html#a=realfans"
          >
            立即开通
          </a>
        </div>
      </OpenStyled>
    </Modal>
  );
};

export { OpenTipPopup };
